import axios from 'axios'
import config from './config'
import { Toast, Dialog } from 'vx-mobile'
import { encrypt, decrypt} from '../../modules/utils/jsencrypt'
import { a_encrypt, a_decrypt} from '../../modules/utils/crypto'
import { encryptLong, decryptLong} from '../../modules/utils/jsencryptLong'
import CryptoJS from '../../modules/utils/crypto'
import random from '../../modules/utils/random'
// 创建一个错误
function errorCreate(msg) {
  const err = new Error(msg)
  errorLog(err)
  throw err
}

// 记录和显示错误
function errorLog(err) {
  // 显示提示
  Dialog.alert({
    title: '温馨提示',
    content: err.message
  })
}

// 创建一个 axios 实例
const service = axios.create({
  ...config
})
// window.loadingInstance=Toast.loading('loading...');
let masklength=0;
// 请求拦截器
service.interceptors.request.use(
  config => {
    console.log(config.data, '请求')
    masklength++;
    Toast.loading("loading...");

    // console.error("遮罩开始----"+config.url);
    //时间戳
    const timestamp=Date.parse(new Date())+'';
    //用aes加密的整个报文头
    let key=random();
    const bizData=a_encrypt(JSON.stringify(config.data),key);
    console.log(bizData)
    //哈希签名
    const rv=random();
    const hash={
      encryptKey: rv,//随机码
      signMethod: 'sha256',
      timestamp: timestamp,
      bizData: bizData,
      salt: 'sxyh1997'
    };
    let hashS='';
    Object.keys(hash).forEach(function (key) {
      hashS+=hash[key]
    });
    const hashCode=CryptoJS.SHA256(hashS).toString();
    //拼接要发送的数据
    config.data={};
    config.data.bizData=bizData;
    config.data.encryptKey=rv;
    config.data.timestamp=timestamp;
    config.data.signature=hashCode;
    //rsa加密aesKey
    config.data.aesKey=encrypt(key);
    return config
    console.log(config.data.bizData)

    // config.data.bizData="xqbvv4DXb5gTzLfuSdX5wnlaekeIGN7oHPbczt7ALOMAbsp2IJ2jPXSPg4OCQN+V7U5s52P0u+FCCh5qymPJUNzgzY0b6Wkvj6l9jTZtFIgracYN0z1qC0F3vta7PyES3vO2BfRIg+KHoLvAcSCL6WoFpPd5e2Ii9L/JhEsoHc0vTJHcWgn2BcIkul/mxCQed8fX0M7rZZj3DGEYbGyKkp0KIk4aCdz77UBBK6lx1icnIRzDX7h9ZadI11MZQdKjK/lTks8iEvmL8RxYakVzng==";
    // config.data.encryptKey="487fbe81ac6393bc";
    // config.data.timestamp="1589964101707";
    // config.data.signature="b69d29b6d2716602d4e9af9bf6f2787bb068900111876b02f7c03865f64bdd21";
    // //rsa加密aesKey
    // config.data.aesKey="UReJEQhxHaQODmyfgeGIVKC3HCN8KOHABiZ4lc/+gDjfy6rUwG0iYyaFtHTvnVZXtU/jpNRordpXnRoTTyIfEvwxNpVlVnRKbmQFSmazKFCfkO6mclc2vo6SYOdIx6i3i0+OaFBKskX1gW26jwiN13OU62Z7r2JhI6FIqahJH80=";
    // return config



    // const content = encryptLong(config.data.Content);
    // console.log(decryptLong(content))
    // const reqHead = config.data.ReqHead;
    // const reqBody = config.data.ReqBody;
    // config.data = {};
    // config.data.ReqHead = reqHead;
    // config.data.ReqBody = reqBody;
    // config.data.ReqHead.Signature=content;
    // return config
  },
  error => {
    // 发送失败
    console.log(error)
    Promise.reject(error)
  }
);

// 响应拦截器
service.interceptors.response.use(
  response => {
    // Toast.hide();
    masklength--;
    if(masklength==0){
      // loadingInstance.hide();
      Toast.hide();
    }
    // console.log(response.data);
    //  response.data = decryptLong(response.data.ResBody.JsonResult);
    // dataAxios 是 axios 返回数据中的 data
    // const dataAxios = response.data
    return response.data;
  },
  error => {
    masklength--;
    if(masklength==0){
      // loadingInstance.hide();
      Toast.hide();
    }
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误'; break
        case 401: error.message = '未授权，请登录'; break
        case 403: error.message = '拒绝访问'; break
        case 404: error.message = `请求地址出错: ${error.response.config.url}`; break
        case 408: error.message = '请求超时'; break
        case 500: error.message = '服务器内部错误'; break
        case 501: error.message = '服务未实现'; break
        case 502: error.message = '网关错误'; break
        case 503: error.message = '服务不可用'; break
        case 504: error.message = '网关超时'; break
        case 505: error.message = 'HTTP版本不受支持'; break
        default: break
      }
    }else if(error.code=="ECONNABORTED"){
      errorLog({message:"网络超时请重试"})
    }else{
      errorLog(error)
    }

    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/plugins/axios/interceptors.js